import { CheckDTO } from "../app/core/models/checks-model";

/**
 * Mock-Daten fÃ¼r Checks.
 * guid-Felder sind feste Mock-GUIDs.
 * Optionale Ãœbergangsfelder (displayName, projectCode, status, checker*-OIDs, etc.)
 * werden im Mock-Betrieb vom mapCheck() zur Anreicherung des Check-Domain-Modells genutzt.
 */
export const CHECK: CheckDTO[] = [
  // Projekt 2024-0315 â€“ DB BrÃ¼ckenneubau A7
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000001',
    createdAt: '2025-03-10T00:00:00Z',
    description: 'ElektrikprÃ¼fung Leitungsanlage',
    doneAt: null,
    displayName: 'ElektrikprÃ¼fung Leitungsanlage',
    projectCode: '2024-0315',
    status: 0,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000001',
    checker11: '11111111-0000-0000-0000-000000000001',
    checker12: '11111111-0000-0000-0000-000000000002',
    checker2:  '11111111-0000-0000-0000-000000000003',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000002',
    createdAt: '2025-03-20T00:00:00Z',
    description: 'WasserabflussprÃ¼fung BrÃ¼ckenentwÃ¤sserung',
    doneAt: null,
    displayName: 'WasserabflussprÃ¼fung BrÃ¼ckenentwÃ¤sserung',
    projectCode: '2024-0315',
    status: 1,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000002',
    checker11: '11111111-0000-0000-0000-000000000002',
    checker12: '11111111-0000-0000-0000-000000000003',
    checker2:  '11111111-0000-0000-0000-000000000004',
    sharepointFolderPath: 'https://ilse.sharepoint.com/sites/IL-Home/Bibliothek',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-03-20',
    dueDate2: '2025-05-15',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000003',
    createdAt: '2025-02-28T00:00:00Z',
    description: 'SchweiÃŸnahtprÃ¼fung TrÃ¤ger',
    doneAt: null,
    displayName: 'SchweiÃŸnahtprÃ¼fung TrÃ¤ger',
    projectCode: '2024-0315',
    status: 2,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000001',
    checker11: '11111111-0000-0000-0000-000000000003',
    checker12: '11111111-0000-0000-0000-000000000004',
    checker2:  '11111111-0000-0000-0000-000000000005',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-02-28',
    dueDate2: '2025-04-10',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000004',
    createdAt: '2025-01-15T00:00:00Z',
    description: 'BrÃ¼ckenprÃ¼fung gemÃ¤ÃŸ DIN 1076',
    doneAt: '2025-03-01T00:00:00Z',
    displayName: 'BrÃ¼ckenprÃ¼fung gemÃ¤ÃŸ DIN 1076',
    projectCode: '2024-0315',
    status: 3,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000001',
    checker11: '11111111-0000-0000-0000-000000000004',
    checker12: '11111111-0000-0000-0000-000000000005',
    checker2:  '11111111-0000-0000-0000-000000000001',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-01-15',
    dueDate2: '2025-03-01',
  },
  // Projekt 2024-0528 â€“ Siemens Anlagenbau Elektrotechnik
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000005',
    createdAt: '2025-04-05T00:00:00Z',
    description: 'MaterialprÃ¼fung Stahlbauteile',
    doneAt: null,
    displayName: 'MaterialprÃ¼fung Stahlbauteile',
    projectCode: '2024-0528',
    status: 0,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000003',
    checker11: '11111111-0000-0000-0000-000000000005',
    checker12: '11111111-0000-0000-0000-000000000001',
    checker2:  '11111111-0000-0000-0000-000000000002',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-04-05',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000006',
    createdAt: '2025-04-18T00:00:00Z',
    description: 'KorrosionsschutzprÃ¼fung AuÃŸenfassade',
    doneAt: null,
    displayName: 'KorrosionsschutzprÃ¼fung AuÃŸenfassade',
    projectCode: '2024-0528',
    status: 1,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000003',
    checker11: '11111111-0000-0000-0000-000000000001',
    checker12: '11111111-0000-0000-0000-000000000002',
    checker2:  '11111111-0000-0000-0000-000000000003',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: true,
    dueDate1: '2025-04-18',
    dueDate2: '2025-06-01',
  },
  // Projekt 2023-1102 â€“ Stadtwerke MÃ¼nchen Versorgungsleitungen
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000007',
    createdAt: '2025-05-10T00:00:00Z',
    description: 'DruckprÃ¼fung Wasserleitung DN200',
    doneAt: null,
    displayName: 'DruckprÃ¼fung Wasserleitung DN200',
    projectCode: '2023-1102',
    status: 0,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000005',
    checker11: '11111111-0000-0000-0000-000000000002',
    checker12: '11111111-0000-0000-0000-000000000003',
    checker2:  '11111111-0000-0000-0000-000000000004',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-05-10',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000008',
    createdAt: '2025-03-25T00:00:00Z',
    description: 'DichtheitsprÃ¼fung Abwasserkanal',
    doneAt: null,
    displayName: 'DichtheitsprÃ¼fung Abwasserkanal',
    projectCode: '2023-1102',
    status: 2,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000005',
    checker11: '11111111-0000-0000-0000-000000000003',
    checker12: '11111111-0000-0000-0000-000000000004',
    checker2:  '11111111-0000-0000-0000-000000000005',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-03-25',
    dueDate2: '2025-05-20',
  },
  // Projekt 2023-0819 â€“ Autobahn GmbH StraÃŸenbau
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000009',
    createdAt: '2025-04-22T00:00:00Z',
    description: 'TragfÃ¤higkeitsprÃ¼fung Fahrbahndecke',
    doneAt: null,
    displayName: 'TragfÃ¤higkeitsprÃ¼fung Fahrbahndecke',
    projectCode: '2023-0819',
    status: 1,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000002',
    checker11: '11111111-0000-0000-0000-000000000004',
    checker12: '11111111-0000-0000-0000-000000000005',
    checker2:  '11111111-0000-0000-0000-000000000001',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-04-22',
    dueDate2: '2025-06-15',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000010',
    createdAt: '2025-02-10T00:00:00Z',
    description: 'Baugrunduntersuchung Widerlager',
    doneAt: '2025-03-28T00:00:00Z',
    displayName: 'Baugrunduntersuchung Widerlager',
    projectCode: '2023-0819',
    status: 3,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000002',
    checker11: '11111111-0000-0000-0000-000000000005',
    checker12: '11111111-0000-0000-0000-000000000001',
    checker2:  '11111111-0000-0000-0000-000000000002',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-02-10',
    dueDate2: '2025-03-28',
  },
  // Projekt 2024-0201 â€“ Flughafen Hamburg Infrastruktur
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000011',
    createdAt: '2025-05-30T00:00:00Z',
    description: 'StatikprÃ¼fung Fundamente Terminal',
    doneAt: null,
    displayName: 'StatikprÃ¼fung Fundamente Terminal',
    projectCode: '2024-0201',
    status: 0,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000004',
    checker11: '11111111-0000-0000-0000-000000000001',
    checker12: '11111111-0000-0000-0000-000000000003',
    checker2:  '11111111-0000-0000-0000-000000000005',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: true,
    dueDate1: '2025-05-30',
  },
  {
    guid: 'aaaaaaaa-0000-0000-0000-000000000012',
    createdAt: '2025-05-12T00:00:00Z',
    description: 'WerkstoffprÃ¼fung Betonfertigteile',
    doneAt: null,
    displayName: 'WerkstoffprÃ¼fung Betonfertigteile',
    projectCode: '2024-0201',
    status: 1,
    reworkStatus: 0,
    creator:   '11111111-0000-0000-0000-000000000004',
    checker11: '11111111-0000-0000-0000-000000000002',
    checker12: '11111111-0000-0000-0000-000000000004',
    checker2:  '11111111-0000-0000-0000-000000000001',
    sharepointFolderPath: '',
    directoryPFolderPath: '',
    isConsultant: false,
    dueDate1: '2025-05-12',
    dueDate2: '2025-07-01',
  },
]
